import { Link } from "react-router-dom";

const footerLinks = {
  navigation: [
    { path: "/", label: "首页" },
    { path: "/category", label: "赛事资讯" },
    { path: "/about", label: "关于我们" },
  ],
  categories: [
    { path: "/category?tab=football", label: "足球" },
    { path: "/category?tab=basketball", label: "篮球" },
    { path: "/category?tab=tennis", label: "网球" },
    { path: "/category?tab=esports", label: "电竞" },
    { path: "/category?tab=baseball", label: "棒球" },
  ],
  download: [
    { label: "开云体育下载", href: "#download" },
    { label: "开云体育iOS下载", href: "#download" },
    { label: "开云体育安卓下载", href: "#download" },
    { label: "开云体育官方下载", href: "#download" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-basketball-line text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                开云体育
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              开云体育官方正版APP下载平台，支持iOS与Android系统。安全可靠、海量赛事、实时赔率，畅享极速体育投注体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              <a href="/" className="cursor-pointer hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              <a href="/category" className="cursor-pointer hover:text-primary-400 transition-colors">赛事分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">下载入口</h4>
            <ul className="space-y-2.5">
              {footerLinks.download.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-4 pt-4 border-t border-background-800">
              <p className="text-sm text-background-400">
                客服邮箱：<a href="mailto:service@kaiyunsports.com" className="text-primary-400 cursor-pointer hover:text-primary-300">service@kaiyunsports.com</a>
              </p>
              <p className="text-sm text-background-400 mt-1">
                客服热线：<strong className="text-background-300">400-888-9999</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 开云体育 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors">
              隐私政策
            </a>
            <a href="/about" className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors">
              服务条款
            </a>
            <a href="/about" className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}